import styled, { css } from 'styled-components';
import { Link } from 'react-router';

const StyledLink = styled(Link)<{ color?: string }>`
  ${({ theme: { colors }, color }) => css`
    color: ${colors[color] || colors.primary}
    text-decoration: none;
  `}
`;

export default StyledLink;
